import { Injectable } from '@angular/core';
import { createEntityState, GenericEntityStateClass } from '../../../state/entity.state';
import { EntityService } from '../../../services/entity.service';
import { SchoolClassEntity } from '../school-class.entity';

export const STATE_NAME = 'schoolClassEntity';

export const SchoolClassEntityState: GenericEntityStateClass<SchoolClassEntity> =
  createEntityState<SchoolClassEntity>(STATE_NAME);

@Injectable({ providedIn: 'root' })
export class SchoolClassEntityService extends EntityService<SchoolClassEntity> {
  constructor() {
    super();
    this.resourceType = 'school-classes';
    this.stateClass = SchoolClassEntityState;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  allByQuery(query: Record<string, any> = {}) {
    const stateClass = this.stateClass;
    const sliceName = STATE_NAME;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (storeState: any): SchoolClassEntity[] => {
      const slice = storeState[sliceName];
      return stateClass.allByQuery(slice, { query });
    };
  }
}
